;(function ($) {

	'use strict';

	var swiperAlbion = new Swiper(".swiper--albion", {
		spaceBetween: 30,
		// effect: "fade",
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});

	const playPauseBtn = document.getElementById("playPauseBtn");
	if (playPauseBtn) {

		let isPlaying = true;
		playPauseBtn.addEventListener("click", () => {
			if (isPlaying) {
				swiperAlbion.autoplay.stop();
				alert('stop');
				// playPauseBtn.textContent = "▶️ Play";
			} else {
				swiperAlbion.autoplay.start();
				alert('play');
				// playPauseBtn.textContent = "⏸ Pause";
			}
			isPlaying = !isPlaying;
		});

	}


	// bootstrap - open all accordion items
	// const toggleBtn = document.getElementById('toggleAll');
  // let allOpen = false;
  // toggleBtn.addEventListener('click', () => {
  //   const collapses = document.querySelectorAll('.accordion .accordion-collapse');
  //   collapses.forEach(collapse => {
  //     if (allOpen) {
  //       bootstrap.Collapse.getOrCreateInstance(collapse).hide();
  //     } else {
  //       bootstrap.Collapse.getOrCreateInstance(collapse).show();
  //     }
  //   });
  //   allOpen = !allOpen;
  //   toggleBtn.textContent = allOpen ? 'Zavřít všechny' : 'Otevřít všechny';
  // });

	$('.accordion__toggleAll').on('click', function () {
		
		let $this = $(this);
		let $items = $this.closest('.accordion').find('.collapse');
		
		if($this.hasClass('opened')) {			
			$items.each(function(){
				new bootstrap.Collapse(this, {toggle: false }).hide();
				$this.find('.accordion-button').addClass('collapsed');
			});
		}
		else {
			$items.each(function(){
				new bootstrap.Collapse(this, {toggle: false }).show();
				$this.find('.accordion-button').removeClass('collapsed');
			});
		}

		
		$this.find('.openText').toggleClass('d-none');
		$this.find('.closeText').toggleClass('d-none');
		$this.toggleClass('opened');

	});

	// toggle parameters on car card
	$('.card__parameters-toggle').on('click', function (e) {

		let $this = $(this);
		let $card = $this.closest('.card');
		let $hidden = $card.find('.card__parameters-hidden');

		$hidden.toggleClass('d-none');
		$this.find('.underline span').toggleClass('d-none');
	});

	
})(jQuery);